// Contrato único de `GET /api/v1/me` (Parte 3.6, REQ-AUTH-028; plano D-F), gerado de `schema.d.ts`
// (`contracts/openapi/v1.json`, schema `IdentityMeResponse`) — GIY-036 fechou o tipo escrito à mão do M0.
import type { GiyusClient } from './client';
import type { components } from './schema';

/** Valores de `user.kind` (Parte 3.4 `User.Kind`). */
export type UserKind = 'Human' | 'Service' | 'TemporaryHuman';
/** Valores de `user.mfa.methods[]` (Parte 3.4 `MfaMethod.Type`). */
export type MfaMethod = 'Totp' | 'RecoveryCodes' | 'SmsOtp';
export type ScopeType = 'Network' | 'Tenant' | 'Site' | 'Study';

/** Resposta de `GET /api/v1/me` — contrato único consumido tal qual pelo shell. */
export type MeResponse = components['schemas']['IdentityMeResponse'];
export type MeUser = MeResponse['user'];
export type MePerson = NonNullable<MeResponse['person']>;
export type MePersonLink = MePerson['activeLinks'][number];
export type MeNetworkAccess = MeResponse['networkAccess'];
/** Um tenant com atribuição ou delegação vigente. */
export type MeContext = MeResponse['contexts'][number];
export type MeSite = MeContext['sites'][number];
export type MeEffectiveRole = MeContext['effectiveRoles'][number];
export type MeContextLink = MeContext['activeLinks'][number];
export type MeSession = NonNullable<MeResponse['session']>;

/** Rota do contrato único (`SelfScope`). */
export const ME_PATH = '/api/v1/me' as const;

/** Lê `GET /api/v1/me` pelo cliente tipado; os middlewares (bearer, correlação, idioma) se aplicam e erros viram `GiyusApiError`. */
export async function getMe(client: GiyusClient): Promise<MeResponse> {
  const { data } = await client.GET(ME_PATH);
  if (!data) {
    throw new Error(`GET ${ME_PATH} returned no body`);
  }
  return data;
}
